import { Box, Spacer, Text } from '@jfs/ui-new'
import { FC, useState } from 'react'
import Footer from '../../comps/Footer'
import { Modal, ModalTypes } from '../../comps/ModalWeb'
import Navbar from '../../comps/Nav'
import NavMob from '../../comps/NavMobile'
import { RichText } from '../../comps/RichText'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth, isTabletWidth, useWindowDimensions } from '../../util/util'
import { COMPLIANTS_ESCALATION_DATA } from './Data'
import { styles } from './styles'

const ComplaintsEscalation: FC = () => {
  const [navVisible, setNavVisible] = useState(false)
  const setVisiblity = (): void => {
    document.body.style.overflow = 'scroll' // body scroll disabled
    setNavVisible(false)
  }
  const handleNav = (): void => {
    document.body.style.overflow = 'hidden' // body scroll disabled
    setNavVisible((prev) => !prev)
  }
  const nav = (
    <Box>
      <NavMob onPress={setVisiblity} />
    </Box>
  )
  const respPadding = usePadding()
  const width = useWindowDimensions()
  const isMobile = isMobileWidth(width)
  const isTab = isTabletWidth(width)
  const { subHeaderSize } = useFontSize()

  return (
    <>
      <Modal view={nav} visible={navVisible} onPress={setVisiblity} type={ModalTypes.NAVBAR_RIGHT} />
      <Navbar onPress={handleNav} isLightBackground={true} />
      <Box {...styles.container}>
        <Box ph={respPadding} bg={'WHITE'}>
          <Spacer direction={'vertical'} size={isMobile || isTab ? 24 : 100} />
          <Text
            fontSize={subHeaderSize}
            fontFamily="jiotype-black"
            title={'Complaint Resolution and Escalation Matrix'}
            textAlign={'center'}
          />
          <Spacer direction={'vertical'} size={isMobile ? 24 : 56} />
          <RichText initialData={JSON.stringify(COMPLIANTS_ESCALATION_DATA)} />
          <Spacer direction={'vertical'} size={32} />
        </Box>
        <Box {...styles.footerBackground}>
          <Footer />
        </Box>
      </Box>
    </>
  )
}

export { ComplaintsEscalation as default }
